export interface LabelProps
  extends React.DetailedHTMLProps<
    React.LabelHTMLAttributes<HTMLLabelElement>,
    HTMLLabelElement
  > {}

export default Object.assign(
  ({ children, className = '', ...rest }: LabelProps) => {
    return (
      <label className={`label ${className}`} {...rest}>
        {children}
      </label>
    );
  },
  {},
);
